import React from "react";
import Button from "../Button/Button";
import "./ChatText.scss";
import DeviceContext from "../../Services/identifyDevice";
import callSupport from "../../../assets/icons/call.png";
import InfoModal from "../InfoModal/InfoModal";
import PanSample from "../../../assets/pan_sample.jpg";
import { pan } from "../../utils/regex";

export interface ChatTextProps {
  className?: string;
  panPageFlag?: boolean;
}

const ChatText: React.FC<ChatTextProps> = (props) => {
  const [instantHelpReadMoreFlag, setInstantHelpReadMoreFlag] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    console.log(DeviceContext().isMobile);
  }, [DeviceContext().isMobile]);

  let readMoreFlagToggle = () => {
    console.log("click");
    if (!instantHelpReadMoreFlag) setInstantHelpReadMoreFlag(true);
    else setInstantHelpReadMoreFlag(false);
  };

  console.log(DeviceContext().isMobile, "HELLO");

  return (
    <div>
      {props.panPageFlag ? (
        <div className="">
          {DeviceContext().isMobile ? (
            <div>
              {instantHelpReadMoreFlag ? (
                <div className="instant-help-modal-mobile">
                  <InfoModal
                    width={DeviceContext().isMobile ? "400px" : "354px"}
                  >
                    <div className="" style={{ padding: "8px" }}>
                      <div style={{ marginBottom: "28px" }}>
                        <div
                          className=""
                          style={{ float: "left", width: "95%" }}
                        >
                          <p
                            className="blue text-center"
                            style={{ color: "#434343" }}
                          >
                            Instant Help!!!
                          </p>
                        </div>
                        <div
                          style={{
                            float: "right",
                            width: "3%",
                            color: "gray",
                            cursor: "pointer",
                          }}
                          onClick={readMoreFlagToggle}
                        >
                          x
                        </div>
                      </div>
                      <p>
                        We hope you're ready to begin your onboarding journey
                        with us using your PAN Card. Follow these simple steps
                        to ensure a smooth process:
                        <h3>Are you handy with your PAN Card:</h3>
                        <ul className="instant-help-ul">
                          <li>Have your PAN card handy.</li>
                          <li>
                            Make sure to upload it in a horizontal format for
                            clear visibility, as it will be shared with the KYC
                            Registration Agency (KRA) if not KRA.
                          </li>
                        </ul>
                        <h3>Why do we require PAN Card?</h3>
                        <ul className="instant-help-ul">
                          <li>
                             Your PAN card is needed to verify your name with
                            the Income Tax website.
                          </li>
                        </ul>
                        <h3> How to Upload a PAN Card?</h3>
                        <ul className="instant-help-ul">
                          <li>
                            Upload a color image copy of your PAN card, ensure
                            that it is properly cropped in a horizontal format.
                          </li>
                          <li>
                            Our system will automatically read and fill in your
                            First Name, Middle Name, Last Name, Date of Birth,
                            and PAN Card Number.
                          </li>
                          <li>
                            If any information is incorrect, you can edit it
                            before submitting.
                          </li>
                        </ul>
                        <h3>Information Verification:</h3>
                        <p>
                          The data will be sent to the Income Tax Department for
                          verification. Verification is necessary to open your
                          account.
                        </p>
                        <p>Handling Name Mismatch Errors:</p>
                        <ul className="instant-help-ul">
                          <li>
                            If you get a "Name not Matched" error, you can
                            verify your name using this link:{" "}
                            <a
                              href="https://eportal.incometax.gov.in/iec/foservices/#/pre-login/verifyYourPAN"
                              target="_blank"
                            >
                              Verify Your PAN
                            </a>
                          </li>
                          <li>
                            {" "}
                            Enter the Name as per Aadhar / Bank / Name that you
                            have entered while entering PAN Card.
                          </li>
                        </ul>
                        <p>
                           Note: This may happen only if you have changed your
                          Name Post Marriage or Pan Card is issued prior to 2012
                          as per Income Tax Authorities.
                        </p>
                        <h3>Tips for Smooth Processing:</h3>
                        <ul>
                          <li>
                            Always upload the original or a colour scanned image
                            of your PAN card.
                          </li>
                          <li>
                            Ensure that the Name, Date of Birth, and Photo on
                            your PAN card are clearly visible.
                          </li>
                        </ul>
                        {/* <div className="text-center">
                          <img
                            className="pan_image_sample"
                            src={PanSample}
                            alt={"pan-sample"}
                          />
                        </div>
                        <ul className="instant-help-ul">
                          <li>
                            Make sure the following details are clear on your
                            pan card
                          </li>
                        </ul>
                        <div className="nested-list instant-help-ul">
                          <ul>
                            <li>
                              Always upload Original or Colored Scanned Pan Card
                              Image
                            </li>
                            <li>PAN card number</li>
                            <li>Date of birth</li>
                            <li>Photo</li>
                          </ul>
                        </div> */}
                      </p>
                    </div>
                  </InfoModal>
                </div>
              ) : (
                ""
              )}
              <div className="fixed-card">
                {/* <div style={{ float: "left", width: "70%" }}>
                  <h4> Can't see your face?</h4>
                </div> */}
                <div style={{ float: "left", width: "30%" }}>
                  <button
                    className={`instant-help-button ${
                      instantHelpReadMoreFlag ? "color-red" : "color-blue"
                    }`}
                    onClick={readMoreFlagToggle}
                  >
                    ? instant help!!
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className={"chatText card " + props.className}>
              {instantHelpReadMoreFlag ? (
                <div className="f-modal">
                  <div className="f-modal-content">
                    <div className="" style={{ padding: "8px" }}>
                      <div style={{ marginBottom: "28px" }}>
                        <div
                          className=""
                          style={{ float: "left", width: "95%" }}
                        >
                          <p
                            className="blue text-center"
                            style={{ color: "#434343" }}
                          >
                            Instant Help!!!
                          </p>
                        </div>
                        <div
                          style={{
                            float: "right",
                            width: "3%",
                            color: "gray",
                            cursor: "pointer",
                          }}
                          onClick={readMoreFlagToggle}
                        >
                          x
                        </div>
                      </div>
                      <p>
                        We hope you're ready to begin your onboarding journey
                        with us using your PAN Card. Follow these simple steps
                        to ensure a smooth process:
                        <h3>Are you handy with your PAN Card:</h3>
                        <ul className="instant-help-ul">
                          <li>Have your PAN card handy.</li>
                          <li>
                            Make sure to upload it in a horizontal format for
                            clear visibility, as it will be shared with the KYC
                            Registration Agency (KRA) if not KRA.
                          </li>
                        </ul>
                        <h3>Why do we require PAN Card?</h3>
                        <ul className="instant-help-ul">
                          <li>
                             Your PAN card is needed to verify your name with
                            the Income Tax website.
                          </li>
                        </ul>
                        <h3> How to Upload a PAN Card?</h3>
                        <ul className="instant-help-ul">
                          <li>
                            Upload a color image copy of your PAN card, ensure
                            that it is properly cropped in a horizontal format.
                          </li>
                          <li>
                            Our system will automatically read and fill in your
                            First Name, Middle Name, Last Name, Date of Birth,
                            and PAN Card Number.
                          </li>
                          <li>
                            If any information is incorrect, you can edit it
                            before submitting.
                          </li>
                        </ul>
                        <h3>Information Verification:</h3>
                        <p>
                          The data will be sent to the Income Tax Department for
                          verification. Verification is necessary to open your
                          account.
                        </p>
                        <p>Handling Name Mismatch Errors:</p>
                        <ul className="instant-help-ul">
                          <li>
                            If you get a "Name not Matched" error, you can
                            verify your name using this link:{" "}
                            <a
                              href="https://eportal.incometax.gov.in/iec/foservices/#/pre-login/verifyYourPAN"
                              target="_blank"
                            >
                              Verify Your PAN
                            </a>
                          </li>
                          <li>
                            {" "}
                            Enter the Name as per Aadhar / Bank / Name that you
                            have entered while entering PAN Card.
                          </li>
                        </ul>
                        <p>
                           Note: This may happen only if you have changed your
                          Name Post Marriage or Pan Card is issued prior to 2012
                          as per Income Tax Authorities.
                        </p>
                        <h3>Tips for Smooth Processing:</h3>
                        <ul>
                          <li>
                            Always upload the original or a colour scanned image
                            of your PAN card.
                          </li>
                          <li>
                            Ensure that the Name, Date of Birth, and Photo on
                            your PAN card are clearly visible.
                          </li>
                        </ul>
                        {/* <div className="text-center">
                          <img
                            className="pan_image_sample"
                            src={PanSample}
                            alt={"pan-sample"}
                          />
                        </div>
                        <ul className="instant-help-ul">
                          <li>
                            Make sure the following details are clear on your
                            pan card
                          </li>
                        </ul>
                        <div className="nested-list instant-help-ul">
                          <ul>
                            <li>
                              Always upload Original or Colored Scanned Pan Card
                              Image
                            </li>
                            <li>PAN card number</li>
                            <li>Date of birth</li>
                            <li>Photo</li>
                          </ul>
                        </div> */}
                      </p>
                      {/* <p>
                        We hope you're ready to begin your onboarding journey
                        with us using your PAN Card. Follow these simple steps
                        to ensure a smooth process:
                        <ul className="instant-help-ul">
                          <li>Click on selfie console</li>
                          <li>
                            You will be prompted to give access to your camera
                            and location-allow when asked.
                          </li>
                          <li>
                            If your laptop or desktop doesn't have a camera
                            don't worry! Enable the toggle button below the
                            selfie console and you'll get a link to your selfie
                            via SMS on your registered mobile device.
                          </li>
                          <li>
                            Enter your PAN and Aadhaar details to validate your
                            PAN-Aadhaar seeding check.
                          </li>
                          <li>
                            Remember to keep your PAN card handy. You'll need to
                            upload it in horizontal format so that it's clear
                            and can be shared with KRA.
                          </li>
                        </ul>
                        <div className="text-center">
                          <img
                            className="pan_image_sample"
                            src={PanSample}
                            alt={"pan-sample"}
                          />
                        </div>
                        <ul>
                          <li>
                            Make sure the following details are clear on your
                            pan card
                          </li>
                        </ul>
                        <div className="nested-list instant-help-ul">
                          <ul>
                            <li>
                              Always upload Original or Colored Scanned Pan Card
                              Image
                            </li>
                            <li>PAN card number</li>
                            <li>Date of birth</li>
                            <li>Photo</li>
                          </ul>
                        </div>
                      </p> */}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <p className="blue">Instant Help!!!</p>
              <p></p>

              <p>
                We hope you're ready to begin your onboarding journey with us
                using your PAN Card. Follow these simple steps to ensure a
                smooth process.
              </p>

              <p className="blue cursor-pointer" onClick={readMoreFlagToggle}>
                Read More
              </p>
            </div>
          )}
        </div>
      ) : (
        <div>
          {DeviceContext().isMobile ? (
            <div className="tooltip">
              <div className="callIcon">
                <span>
                  <img src={callSupport} alt="Call Support" />
                </span>
              </div>
              <div className="callText">Call</div>
              <div className="tooltiptext">
                <p>
                  <a href="tel:18001023335" className="blue">
                    1800 102 3335
                  </a>
                </p>
                <p>Monday to Saturday : 10:00 AM - 6:00 PM</p>
                {/* <p>Saturday 10 AM - 4 PM</p> */}
              </div>
            </div>
          ) : (
            <div className={"chatText " + props.className}>
              <p>For any queries contact us:</p>
              <p>
                <a href="tel:18001023335" className="blue">
                  1800 102 3335
                </a>
              </p>
              <p>*Weekdays 10:00 AM - 6:00 PM</p>
              <p>*Saturday 10:00 AM - 5:00 PM</p>
              <p>(*Except on 1st Saturday and Trading Holidays.)</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default ChatText;
